import React, { Component } from 'react'
import { painel, fieldset, Item, Input } from 'scorpion-core';
import EditorSeletor from '../../editor/SeletorUidCustomForm'
import Tabela from './Tabela'


import { Field } from 'redux-form';
function componentRelEspelho(comp, dados) {
    return ("")
}

function component(item,propsview) {

    return (<Item key={item.sha} style={{ flex: 1 }}>
        <Field name={item.field} label={item.label}
            item={item} propsview={propsview} component={Tabela} />
    </Item>)
}

const modelo = {
    typeComponente: "PesquisaItensCustomForm",
    field: "itens",
    label: "Lista de Itens Custom",
    nomeItem: "Item",
    componentes: [
        { field: "uid", label: "UID", desativado :true, typeComponente: "Input" },
        { field: "titulo", label: "Titulo",desativado :true,  typeComponente: "Input", },
    ],
    customFormUid: "",


}
const comp = {
    typeComponente: "PesquisaItensCustomForm",
    configView: {
        nome: "Lista de Itens Custom",
        modelo,
        editores: {
            customFormUid: EditorSeletor
        },
    },
    componentRelEspelho,
    component
}



export default comp;


// WEBPACK FOOTER //
// ./src/routes/sistema/DinamicComponenets/components/PesquisaItensCustomForm/TabelaItensComp.js